import { render } from "./AdminLoadDialog.vue?vue&type=template&id=f3581f86"
import script from "./AdminLoadDialog.vue?vue&type=script&lang=js"
export * from "./AdminLoadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__